/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ButtonGroup, Card, Col, Container, Row } from "react-bootstrap";
import { Button, DropDown, Input, ModalComp } from "../../../components";
import { useNavigate, useParams } from "react-router-dom";
import {
  DeleteRentingProduct,
  GetRentingProductDetails,
  UpdateRentingProductDetails,
} from "../../../utilities/api/stock/rent";
import { toast } from "react-toastify";
import {
  validateCharacterLength,
  validatePositiveValue,
  nameValidation2,
  numberValidation,
} from "../../../utilities/utils";
import { messages } from "../../../utilities/Messages";

const getMessage = messages.stocks;

const errorInit = {
  name: "",
  costPrice: "",
  rentingPrice: "",
  sacCode: "",
  totalQuantity: "",
  igst: "",
  cgst: "",
  sgst: "",
  remarkText: "",
};

const UpdateServicesInventory = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState({
    name: "",
    facilityId: "",
    costPrice: "" || 0,
    rentingPrice: "",
    sacCode: "",
    totalQuantity: "",
    igst: "",
    cgst: "",
    sgst: "",
    isActive: "",
    remarkText: "",
    updatedAt: "",
    availableQuantity: "",
    onRentQuantity: "",
  });
  const [error, setError] = useState({ ...errorInit });
  const [archive, setArchive] = useState(false);
  const [originalData, setOriginalData] = useState({}) as any;

  useEffect(() => {
    GetRentingProductDetails(`${id || ""}`)
      .then((res) => {
        const _data = {
          ...(res?.data || {}),
          igst: res?.data?.rentingProductTaxes?.find?.(
            (_tax: any) => _tax?.tax?.type === "IGST"
          )?.percentage,
          cgst: res?.data?.rentingProductTaxes?.find?.(
            (_tax: any) => _tax?.tax?.type === "CGST"
          )?.percentage,
          sgst: res?.data?.rentingProductTaxes?.find?.(
            (_tax: any) => _tax?.tax?.type === "SGST"
          )?.percentage,
          isActive: `${res?.data?.isActive}`,
        };
        setOriginalData(_data);
        setData({ ...data, ..._data });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || getMessage.something_wrong);
      });
  }, []);

  const updateData = (key: any, value: any = "") => {
    if (typeof key === "object") {
      setData((oldSession) => ({ ...oldSession, ...key }));
    } else {
      setData((oldSession) => ({ ...oldSession, [key]: value }));
    }
  };

  const isValid = () => {
    if (
      !data?.name ||
      nameValidation2(data?.name) == null ||
      !data?.cgst ||
      !data?.costPrice ||
      data?.costPrice.toString().length > 10 ||
      numberValidation(data?.costPrice) == null ||
      data?.rentingPrice.length > 10 ||
      numberValidation(data?.rentingPrice) == null ||
      !data?.rentingPrice ||
      data?.sacCode.length != 6 ||
      !data?.igst ||
      !data?.sgst ||
      numberValidation(Number(data?.igst)) == null ||
      numberValidation(Number(data?.cgst)) == null ||
      numberValidation(Number(data?.sgst)) == null ||
      (Number(originalData?.availableQuantity) !==
        Number(data.availableQuantity) &&
        data?.remarkText?.length <= 0)
    ) {
      setError({
        name: data?.name
          ? nameValidation2(data?.name) == null
            ? getMessage.name_matches
            : ""
          : getMessage.serviceName_required,
        costPrice: data?.costPrice
          ? data?.costPrice.toString().length > 10
            ? getMessage.serviceCostPrice_maxLength
            : numberValidation(data?.costPrice) == null
              ? getMessage.serviceCostPrice_match
              : ""
          : getMessage.serviceCostPrice_required,
        rentingPrice: data?.rentingPrice
          ? data?.rentingPrice.length > 10
            ? getMessage.rentingPrice_maxLength
            : numberValidation(data?.rentingPrice) == null
              ? getMessage.rentingPrice_matches
              : ""
          : getMessage.rentingPrice_required,

        sacCode: data?.sacCode.length != 6 ? getMessage.sacCode_length : "",
        totalQuantity:
          Number(data?.totalQuantity) > 0
            ? data?.totalQuantity.toString().length > 4
              ? getMessage.totalQuantity_maxLength
              : ""
            : getMessage.serviceTotalQuantity_required,
        igst:
          Number(data?.igst) <= 0
            ? getMessage.IGST_required
            : numberValidation(Number(data?.igst)) != null
              ? ""
              : getMessage.IGST_valueType,
        cgst:
          Number(data?.cgst) <= 0
            ? getMessage.CGST_required
            : numberValidation(Number(data?.cgst)) != null
              ? ""
              : getMessage.CGST_valueType,
        sgst:
          Number(data?.sgst) <= 0
            ? getMessage.SGST_required
            : numberValidation(Number(data?.sgst)) != null
              ? ""
              : getMessage.SGST_valueType,
        remarkText:
          Number(originalData?.availableQuantity) !==
            Number(data.availableQuantity) && data?.remarkText?.length <= 0
            ? getMessage.remarkText_required
            : data?.remarkText?.length > 200
              ? getMessage.remark_maxLength
              : "",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (isValid()) {
      let payload = {
        costPrice: Number(data?.costPrice),
        rentingPrice: Number(data?.rentingPrice),
        availableQuantity: Number(data?.availableQuantity),
        sacCode: data?.sacCode,
        igst: Number(data?.igst),
        cgst: Number(data?.cgst),
        sgst: Number(data?.sgst),
        remarkText: data?.remarkText,
        isActive: data?.isActive,
      };
      const result = await UpdateRentingProductDetails(`${id || ""}`, payload);
      if (result?.status === 200) {
        toast.success(result?.data?.message);
        navigate("/rent-stock");
      } else {
        toast.error(result.response.data.message);
      }
    }
  };


  const setValueWithLength = (key = "", value = "", min = 0, max = 0) => {
    if (validateCharacterLength(value, min, max)) {
      updateData(key, value);
    }
  };

  const setPositiveValue = (key = "", value = "") => {
    if (validatePositiveValue(value)) {
      updateData(key, value);
    }
  };

  const getPercentValue = (amount: number, percent: number) => {
    return (Number(amount) * Number(percent)) / 100;
  };

  const handleDelete = async () => {
    const result = await DeleteRentingProduct(id || "");
    if (result.status === 200) {
      navigate("/rent-stock");
    } else {
      toast.error(result.response.data.message);
    }
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            <div className="page-title align-items-center d-flex justify-content-between">
              <Card.Title className="text-start mb-0">
                Edit or Remove Service Stock
              </Card.Title>
              <ButtonGroup>
                <Button
                  onClick={() => setArchive(true)}
                  type="button"
                  bname="Delete Inventory"
                  name="delete-inventory"
                  id="delete-inventory"
                  className="btn btn-primary rounded-1"
                ></Button>
              </ButtonGroup>
            </div>
            <hr />
            <Row>
              <Col lg={4} className="text-start">
                <div className="fw-semibold mb-3">
                  Product Name: <span className="text-info">{data?.name}</span>{" "}
                </div>
              </Col>
              <Col lg={4} className="text-start">
                <div className="fw-semibold mb-3">
                  Last Inward Quantity:{" "}
                  <span className="text-info">{data?.totalQuantity}</span>{" "}
                </div>
              </Col>
              <Col lg={4} className="text-start">
                <div className="fw-semibold mb-3">
                  Product Value:{" "}
                  <span className="text-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {data?.costPrice?.toFixed(2)}
                  </span>{" "}
                </div>
              </Col>

              <Col lg={4} className="text-start">
                <div className="fw-semibold mb-3">
                  In Service Today:{" "}
                  <span className="text-info">{data?.onRentQuantity}</span>{" "}
                </div>
              </Col>
              <Col lg={4} className="text-start">
                <div className="fw-semibold mb-3">
                  Last Inward Date:{" "}
                  <span className="text-info">{data?.updatedAt}</span>{" "}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="chargesperunit" className="form-label">
                    Charges per Unit for 30 Minuts{" "}
                    <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="text"
                    placeholder="Enter Charges"
                    id="chargesperunit"
                    name="chargesperunit"
                    className="form-control"
                    value={data?.rentingPrice}
                    onChange={(e: any) => {
                      if (/^\d*\.?\d{0,2}$/.test(e.target.value)) {
                        updateData("rentingPrice", e.target.value);
                      }
                    }}
                  />
                  {error?.rentingPrice && (
                    <div className="error-msg">{error?.rentingPrice}</div>
                  )}
                </div>
              </Col>
            </Row>
            <Row className="align-items-end">
              <Col lg={3}>
                <div className="mb-3 text-start" style={{ position: "relative", paddingBottom: "1.2em" }}>
                  <label htmlFor="sac" className="form-label">
                    SAC Number <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="text"
                    placeholder="Enter SAC Number"
                    id="sac"
                    name="sac"
                    className="form-control"
                    value={data?.sacCode}
                    onChange={(e: any) => {
                      if (Number(e?.target?.value) >= 0)
                        setValueWithLength("sacCode", e?.target?.value, 0, 6);
                    }}
                    onKeyDown={(e: any) => e.key === "." && e.preventDefault()}
                  />
                  {error?.sacCode && (
                    <div className="error-msg" style={{ position: "absolute", bottom: 0 }}>{error?.sacCode}</div>
                  )}
                </div>
              </Col>
              <Col lg={2}>
                <div className="mb-3 text-start" style={{ position: "relative", paddingBottom: "1.2em" }}>
                  <label htmlFor="i-gst" className="form-label">
                    IGST (%) <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="text"
                    placeholder="Enter IGST"
                    id="i-gst"
                    name="i-gst"
                    className="form-control"
                    value={data?.igst}
                    onChange={(e: any) => {
                      const igst = e?.target?.value;
                      if (igst >= 0 && igst <= 100) {
                        const _updatedValues = {
                          igst: `${igst}`,
                          cgst: `${igst / 2}`,
                          sgst: `${igst / 2}`,
                        };
                        updateData(_updatedValues);
                      }
                    }}
                  />
                  {error?.igst && (
                    <div className="error-msg" style={{ position: "absolute", bottom: 0 }}>{error?.igst}</div>
                  )}
                </div>
              </Col>
              <Col lg={2}>
                <div className="mb-3 text-start" style={{ position: "relative", paddingBottom: "1.2em" }}>
                  <label htmlFor="c-gst" className="form-label">
                    CGST (%) <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="text"
                    placeholder="Enter CGST"
                    id="c-gst"
                    name="c-gst"
                    className="form-control"
                    value={data?.cgst}
                    onChange={(e: any) => {
                      const cgst = e?.target?.value;
                      const igst = Number(cgst) + Number(data?.sgst);
                      if (igst >= 0 && igst <= 100 && cgst >= 0) {
                        const _updatedValues = {
                          igst: `${igst}`,
                          cgst: `${cgst}`,
                        };
                        updateData(_updatedValues);
                      }
                    }}
                  />
                  {error?.cgst && (
                    <div className="error-msg" style={{ position: "absolute", bottom: 0 }}>{error?.cgst}</div>
                  )}
                </div>
              </Col>
              <Col lg={2}>
                <div className="mb-3 text-start" style={{ position: "relative", paddingBottom: "1.2em" }}>
                  <label htmlFor="s-gst" className="form-label">
                    SGST (%) <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="text"
                    placeholder="Enter SGST"
                    id="s-gst"
                    name="s-gst"
                    className="form-control"
                    value={data?.sgst}
                    onChange={(e: any) => {
                      const sgst = e?.target?.value;
                      const igst = Number(sgst) + Number(data?.cgst);
                      if (igst >= 0 && igst <= 100 && sgst >= 0) {
                        const _updatedValues = {
                          igst: `${igst}`,
                          sgst: `${sgst}`,
                        };
                        updateData(_updatedValues);
                      }
                    }}
                  />
                  {error?.sgst && (
                    <div className="error-msg" style={{ position: "absolute", bottom: 0 }}>{error?.sgst}</div>
                  )}
                </div>
              </Col>
              <Col lg={3}>
                <div className="badge bg-info fst-italic fw-semibold mb-0 mb-3 mb-4 p-2 text-wrap text-start">
                  Service Charges Per 30 Minuts:{" "}
                  <span style={{ whiteSpace: "nowrap" }}>
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {(
                      Number(data?.rentingPrice) +
                      getPercentValue(
                        Number(data?.rentingPrice),
                        Number(data?.igst)
                      )
                    ).toFixed(2)}
                  </span>
                </div>
              </Col>
            </Row>
            <Row className="align-items-end">
              <Col lg={4}>
                <div className="align-items-baseline d-flex mb-3 text-start" style={{ paddingBottom: "1.2em" }}>
                  <label htmlFor="quantity" className="form-label">
                    Available Quantity :{" "}
                  </label>
                  <div className="ms-3 quantity-input">
                    <span
                      className="minus"
                      onClick={() =>
                        setPositiveValue(
                          "availableQuantity",
                          `${Number(data?.availableQuantity) - 1}`
                        )
                      }
                    >
                      -
                    </span>
                    <Input
                      type="text"
                      placeholder="Enter Available Quantity"
                      id="availableQuantity"
                      name="availableQuantity"
                      className="form-control"
                      value={data?.availableQuantity}
                      onChange={(e: any) =>
                        setPositiveValue("availableQuantity", e?.target?.value)
                      }
                    />
                    <span
                      className="plus"
                      onClick={() =>
                        setPositiveValue(
                          "availableQuantity",
                          `${Number(data?.availableQuantity) + 1}`
                        )
                      }
                    >
                      +
                    </span>
                  </div>
                </div>
              </Col>
              <Col lg={4}>
                <div className="mb-3 text-start" style={{  paddingBottom: "1.2em" }}>
                  <label htmlFor="remarks" className="form-label">
                    Remark if quantity Change{" "}
                    <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="text"
                    placeholder=""
                    className="form-control"
                    id="remarks"
                    name="remarks"
                    value={data?.remarkText}
                    onChange={(e: any) =>
                      updateData("remarkText", e?.target?.value)
                    }
                  />
                  {error?.remarkText && (
                    <div className="error-msg" style={{ position: "absolute", bottom: 0 }}>{error?.remarkText}</div>
                  )}
                </div>
              </Col>
              <Col lg={4}>
              <div className="align-items-baseline d-flex mb-3 text-start ">
                <div className="badge bg-info fs-6 fst-italic fw-semibold mb-3 p-2">
                  Value of Stock:{" "} <span className="rupees-symbol">&#8377;</span>{" "}
                  {(
                    Number(data?.costPrice) * Number(data?.totalQuantity)
                  ).toFixed(2)}
                </div>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="facilityname" className="form-label">
                    Status <small className="text-danger">*</small>
                  </label>
                  <DropDown
                    value={data?.isActive}
                    onChange={(e: any) =>
                      updateData("isActive", e.target.value)
                    }
                    name="isActive"
                    id="isActive"
                    className="form-control"
                  >
                    <option hidden disabled value="">
                      Select Facility Status
                    </option>
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </DropDown>

                </div>
              </Col>
              <Col lg={6}></Col>
            </Row>
            <hr />
            <Row>
              <Col className="text-end">
                <Button
                  type="button"
                  bname="Confirm"
                  name="confirm"
                  id="confirm"
                  className="btn btn-primary rounded-1"
                  onClick={handleSubmit}
                ></Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
      <ModalComp
        archive={archive}
        setArchive={setArchive}
        handleDelete={handleDelete}
      />
    </>
  );
};
export { UpdateServicesInventory };
